module.exports = "<div class=\"container instagram\">\n  <h3>Instagram</h3>\n  <div class=\"instagram-wrapper clearfix\">\n    <div *ngFor=\"let instagram of instagrams\" class=\"instagram-image hover-image-wrapper\">\n      <a outlink=\"{{instagram.link}}\" href=\"{{instagram.link}}\" target=\"_blank\">\n        <div class=\"img-scale\" [ngStyle]=\"{'background-image': 'url(' + instagram.image + ')'}\">\n        </div>\n      </a>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/instagram/instagram.component.html
// module id = 1086
// module chunks = 0